import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    simulationCopyName: (name: string) =>
      translate({ id: 'simulations.duplicateName', values: { name } }),
  }))

  return api
}
